import { NAMESPACE_ENUM } from '@/components/shared/file-list/file-list.service';
import { ReportTaskDetailsDTO } from '@/types';

export const getReportRequestPVItems = (reportTask: ReportTaskDetailsDTO) => {
  return {
    'Procès verbal CPMP': { items: reportTask?.pvCpmp || [], nameSpace: NAMESPACE_ENUM.PV },
    'Extraits Procès verbal CPMP': { items: reportTask?.extraitCpmp || [], nameSpace: NAMESPACE_ENUM.SNIPPET },
    'Documents examinés/Justifs CPMP': {
      items: reportTask?.documentCPMP || [],
      nameSpace: NAMESPACE_ENUM.MEETING_REPORT_FOR_MEETING,
    },
    'Procès verbal CNCMP Permanente': { items: reportTask?.pvCncmpPermanente || [], nameSpace: NAMESPACE_ENUM.PV },
    'Extraits Procès verbal CNCMP Permanente': {
      items: reportTask?.extraitCncmpPermanente || [],
      nameSpace: NAMESPACE_ENUM.SNIPPET,
    },
    'Documents examinés/Justifs CNCMP Permanente': {
      items: reportTask?.documentCNCMPPermanente || [],
      nameSpace: NAMESPACE_ENUM.MEETING_REPORT_FOR_MEETING,
    },
    'Procès verbal CNCMP Spécialisée': { items: reportTask?.pvCncmpSpecialisee || [], nameSpace: NAMESPACE_ENUM.PV },
    'Documents examinés/Justifs CNCMP Spécialisée': {
      items: reportTask?.documentCNCMPSpecialisee || [],
      nameSpace: NAMESPACE_ENUM.MEETING_REPORT_FOR_MEETING,
    },
  };
};
